import React, { FunctionComponent } from "react";

const InlineCode: FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => (
  <code className="text-xs border rounded border-gray-300 bg-gray-100 text-oso-fact-red px-1 py-0.5">
    {children}
  </code>
);

export default InlineCode;
